import React, { useContext, useEffect, useState } from "react";
import { doctorProfileFiles } from "../../../Util/API Calls/APIList";
import { LOCALSTORAGEKEY } from "../../../Util/Helper/localStorageUtils";
import { APPLICABLE_ROLE } from "../../DashboardAppointmentsView/Constant";
import DoctorContext from "../ClinicWrapper/DoctorContext";
import "./component-styles.scss";

const DoctorCardComponent = () => {
  const doctor_context = useContext(DoctorContext);
  let userType = localStorage.getItem(LOCALSTORAGEKEY.USER_TYPE);
  let staffClinicAssociation = localStorage.getItem(
    LOCALSTORAGEKEY.STAFF_CLINIC_ASSOCIATION
  );
  let clinicId = localStorage.getItem(LOCALSTORAGEKEY.CLINIC_ID);
  const [profile, setProfile] = useState();

  useEffect(() => {
    const data = localStorage.getItem("doctorProfile")
      ? JSON.parse(localStorage.getItem("doctorProfile"))
      : {};
    setProfile(data);
  }, [localStorage.getItem("doctorProfile")]);

  return (
    <div
      className="doctor-card d-flex justify-content-between"
      id="doctor_card"
    >
      <div>
        <p className="welcome-text">Welcome Back,</p>
        <div className="doctor-name">
          {userType === APPLICABLE_ROLE.STAFF
            ? localStorage.getItem("user_name")
            : localStorage.getItem("doctorName")}
          {/* Dr. Dilip Joseph Wilson" */}
        </div>
        {((clinicId !== "" && clinicId !== null && clinicId !== undefined) ||
          userType === APPLICABLE_ROLE.STAFF) &&
          doctor_context?.doctorRole !== "undefined" && (
            <div
              className={`mt-3 ${
                userType === APPLICABLE_ROLE.STAFF &&
                staffClinicAssociation === "true"
                  ? "staff-tag-container"
                  : "tag-container"
              }`}
            >
              <p className="tag-text">
                {userType === APPLICABLE_ROLE.STAFF
                  ? APPLICABLE_ROLE.STAFF
                  : doctor_context?.doctorRole}
              </p>
            </div>
          )}
      </div>
      {userType === APPLICABLE_ROLE.DOCTOR && (
        <div className="doctor-card-profile-pic">
          <img src={doctorProfileFiles + profile?.profile_picture_url} alt="" />
        </div>
      )}
    </div>
  );
};

export default DoctorCardComponent;
